import { render, staticRenderFns } from "./Keys.vue?vue&type=template&id=11a4ee0a&scoped=true&"
import script from "./Keys.vue?vue&type=script&lang=ts&"
export * from "./Keys.vue?vue&type=script&lang=ts&"
import style0 from "./Keys.vue?vue&type=style&index=0&id=11a4ee0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a4ee0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VDataTable,VIcon})
